import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {
  COACH_CANDIDATE,
  DELETE_PROFILE,
  DELETE_REMINDER,
  GET_CANDIDATE_DECLINE_REASONS,
  GET_CANDIDATE_DISPOSITION_OPTIONS,
  GET_PROFILE,
  MERGE_PROFILE,
  RESET_ALL_CANDIDATES_INFO,
  RESET_CANDIDATE_INFO,
  SAVE_CANDIDATE_REMINDER,
  SET_CANDIDATE_NOTES_STATE,
} from '/redux/action/candidate.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './candidate/auth/signOut';
import getCandidateDeclineReasons from './candidate/getCandidateDeclineReasons';
import getDispositionOptions from './candidate/getDispositionOptions';
import getInfo from './candidate/getInfo';
import resetAllCandidatesInfo from './candidate/resetAllCandidatesInfo';
import resetCandidateInfo from './candidate/resetCandidateInfo';
import setCandidateNotesState from './candidate/setCandidateNotesState';

const initialState = {
  allCandidates: {},
};

export default handleActions(
  {
    [GET_PROFILE]: withPayload(getInfo),
    [COACH_CANDIDATE]: withPayload(getInfo),
    [DELETE_PROFILE]: withPayload(getInfo),
    [MERGE_PROFILE]: withPayload(getInfo),
    [RESET_CANDIDATE_INFO]: withPayload(resetCandidateInfo),
    [RESET_ALL_CANDIDATES_INFO]: withPayload(resetAllCandidatesInfo),
    [SIGN_OUT]: withPayload(authSignOut),
    [SET_CANDIDATE_NOTES_STATE]: withPayload(setCandidateNotesState),
    [GET_CANDIDATE_DECLINE_REASONS]: withPayload(getCandidateDeclineReasons),
    [GET_CANDIDATE_DISPOSITION_OPTIONS]: withPayload(getDispositionOptions),
    [DELETE_REMINDER]: withPayload(getInfo),
    [SAVE_CANDIDATE_REMINDER]: withPayload(getInfo),
  },
  initialState,
);
